import { BodyScriptConfig } from "src/constants/omotiScripts";

/**
 * <body> 終了タグ直前（document.body の末尾）に <script> 要素を挿入する。
 * 生成した script 要素を返すので、不要になったら呼び出し側で除去できる。
 */
export const appendBodyScript = ({
  src,
  attributes,
}: BodyScriptConfig): HTMLScriptElement => {
  const script = document.createElement("script");
  script.src = src;
  Object.entries(attributes).forEach(([key, value]) => {
    script.setAttribute(key, value);
  });
  document.body.appendChild(script);
  return script;
};
